module.exports = __webpack_public_path__ + "img/tarj1-2.0ce345a6.svg";